export default "__VITE_PUBLIC_ASSET__1b7e9615__"